import gql from 'graphql-tag'

export default gql`
mutation deleteBatchTrackingKerry($labelIds: [String!]) {
  deleteBatchTrackingKerry(labelIds: $labelIds) {
    _id
    sendHook
  }
}
`


// WEBPACK FOOTER //
// ./src/graphql/mutations/DeleteBatchTrackingKerry.js